import { gql } from "@apollo/client";

export const GET_ALL_CATEGORIAS_RECLAMO = gql`
  query allCategoriasReclamo {
    allCategoriasReclamo {
        idCategoriaReclamo
        descripcion
    }
}`;

export const adaptCategoriasReclamoArray = (categorias) =>
structuredClone(categorias?.allCategoriasReclamo)?.
map((categoria) => ({
  id: categoria?.idCategoriaReclamo,
  displayName: categoria?.descripcion
}));